<script lang="ts">
	export let filled = false;
</script>

{#if filled}
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class={$$props.class}>
		<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
	</svg>
{:else}
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class={$$props.class}>
		<path d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm0 2c2.21 0 5.2.89 6 2H6c.8-1.11 3.79-2 6-2z" />
	</svg>
{/if}
